import { Injectable } from '@angular/core';
import { MessageTemplateService } from 'src/api/services/message-template.service';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { MessageTemplate } from 'src/api/models/message-template';
import { DistributionListItem } from 'src/api/models/distribution-list-item';
import { CustomerDistribution,Customer } from 'src/api/models';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class MessageTemplateTableService {

    public remoteData: Observable<MessageTemplate[]>;
    private _remoteData: BehaviorSubject<MessageTemplate[]>;

    public loading: boolean = false;
    public loadingItems: boolean = false;
    public customerId: number;

    constructor(
      private readonly service: MessageTemplateService,
      private readonly toasterService: ToastrService) {

      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
      this.remoteData.subscribe(s => console.log(s));
    }

    validate(distribution: MessageTemplate){
      if(distribution.templateName)
      {
        return true;
      }
      return false;
    }

    get(customerId: number) {
      this.customerId = customerId;
      this.loading = true;
      this.service.MessageTemplateGetMessageTemplates(customerId).subscribe(results => {
        this._remoteData.next(results);
        this.loading = false;
      }, err => {
        this.toasterService.error("Failed to Load Message Templates");
        this.loading = false;
      });
    }

    add(customerId: number, messageTemplate: MessageTemplate){
      messageTemplate.customer = {customerId:customerId} as Customer;
      return this.service.MessageTemplateCreateOrUpdate(messageTemplate).subscribe(s => {
        this.get(this.customerId);
        this.toasterService.success("Message Template Created");
      }, e => {
        this.toasterService.error("Message Tempalte Not Created");
      });
    }

    remove(messageTemplateId: number) {
      return this.service.MessageTemplateDelete(messageTemplateId).subscribe(r =>{
        this.get(this.customerId);
        this.toasterService.success("Message Template Deleted");
      }, e => {
        this.toasterService.error("Message Template Not Deleted");
      });
    }

    update(messageTemplate: MessageTemplate){
      return this.service.MessageTemplateCreateOrUpdate(messageTemplate).subscribe(d => {
        this.get(messageTemplate.customer.customerId);
        this.toasterService.success("Message Template Updated");
      }, e => {
        this.toasterService.error("Message Template Not Updated");
      });
    }

}
